import {useContent} from "./useContent";
import FirstSlide from "./FirstSlide";
import SecondSlide from "./SecondSlide";
import ThirdSlide from "./ThirdSlide";
import FourthSlide from "./FourthSlide";
import LastSlide from "./LastSlide";
import {Fragment} from "preact";
import s from "./content.module.css";
import {iconBreadcrumbsArrow, productCartIcon} from "../../../assets";
import {Link} from "preact-router";
import {redirectLinkParser} from "../../../utils";

const Content = (props) => {
    // Destructured props
    const {
        selfServiceAttendanceModalData,
        handleButtonStyle,
        handleClose,
    } = props;

    // Component logic data
    const componentProps = useContent({
        handleButtonStyle
    });

    // Destructured component logic data
    const {
        TOTAL_SLIDES,
        showShoppingButton,
        currentSlide,
        isMobile,
        isLastSlide,
        thirdSlideStage,
        handleThirdSlideStage,
        handleCurrentSlide
    } = componentProps;

    // Dynamic button for when a redirect link exists
    const button =
        !selfServiceAttendanceModalData?.redirect_link ?
            (
                <button
                    type={"button"}
                    className={`${s.continueShopping} ${!showShoppingButton ? "opacity-0 pointer-events-none" : "opacity-100"}`}
                    onClick={() => handleClose()}
                >
                    <img
                        src={productCartIcon}
                        alt="Cart icon"
                    />
                    <span>
                        Continuar comprando
                    </span>
                </button>
            ) : (
                <Link href={`/${redirectLinkParser(selfServiceAttendanceModalData.redirect_link)}`}>
                    <button
                        type={"button"}
                        className={`${s.continueShopping} ${!showShoppingButton ? "opacity-0 pointer-events-none" : "opacity-100"}`}
                        onClick={() => handleClose()}
                    >
                        <img
                            src={productCartIcon}
                            alt="Cart icon"
                        />
                        <span>
                        Continuar comprando
                    </span>
                    </button>
                </Link>
            );

    return (
        <Fragment>
            <div className={`w-full max-w-full h-full relative z-0`}>
                <FirstSlide
                    selfServiceAttendanceModalData={selfServiceAttendanceModalData}
                    currentSlide={currentSlide}
                    handleCurrentSlide={handleCurrentSlide}
                />
                {currentSlide >= 2 && (
                    <ThirdSlide
                        selfServiceAttendanceModalData={selfServiceAttendanceModalData}
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                        stage={thirdSlideStage}
                        setStage={handleThirdSlideStage}
                    />
                )}
                {currentSlide >= 3 && (
                    <FourthSlide
                        selfServiceAttendanceModalData={selfServiceAttendanceModalData}
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                    />
                )}
                {currentSlide >= 4 && (
                    <LastSlide
                        selfServiceAttendanceModalData={selfServiceAttendanceModalData}
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                        handleClose={handleClose}
                    />
                )}
            </div>
            <div className={`${s.buttonsContainer} ${isMobile && currentSlide < 2 ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
                {/* For the last slide */}
                <button
                    type={"button"}
                    className={`${s.mobilePrevSlideButton} ${isLastSlide ? "flex md:hidden" : "hidden"}`}
                    onClick={() => handleCurrentSlide("prev")}
                >
                    {/*<span>*/}
                    {/*    Próximo*/}
                    {/*</span>*/}
                    <img
                        src={iconBreadcrumbsArrow}
                        alt=""
                    />
                </button>
                {button}
                {/* For the other slides */}
                <button
                    type={"button"}
                    className={`${s.mobileNextSlideButton} ${isLastSlide ? "hidden" : "flex md:hidden"}`}
                    onClick={() => handleCurrentSlide()}
                >
                    {/*<span>*/}
                    {/*    Próximo*/}
                    {/*</span>*/}
                    <img
                        src={iconBreadcrumbsArrow}
                        alt=""
                    />
                </button>
            </div>
        </Fragment>
    )
}

export default Content;
